import styled from "@emotion/styled";
var Container = /*#__PURE__*/ styled("div", {
    target: "ex757z70"
})("margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";", function(param) {
    var hasMinSize = param.hasMinSize;
    return hasMinSize ? "min-height: 350px;" : "";
}, "}position:relative;height:100%;min-height:250px;overflow:hidden;border-radius:0.75rem;");
export { Container };
